export const variants = {
  clear: 'var(--foundation-bg-primary-clear)',
  weak: 'var(--foundation-bg-primary-weak)',
} as const

export const sizes = {
  0: 'var(--space-0)',
  0.25: 'var(--space-025)',
  0.5: 'var(--space-05)',
  1: 'var(--space-1)',
  2: 'var(--space-2)',
  3: 'var(--space-3)',
  4: 'var(--space-4)',
  5: 'var(--space-5)',
  6: 'var(--space-6)',
  7: 'var(--space-7)',
  8: 'var(--space-8)',
  9: 'var(--space-9)',
  10: 'var(--space-10)',
  11: 'var(--space-11)',
  12: 'var(--space-12)',
  13: 'var(--space-13)',
  14: 'var(--space-14)',
  15: 'var(--space-15)',
  16: 'var(--space-16)',
  20: 'var(--space-20)',
  24: 'var(--space-24)',
  28: 'var(--space-28)',
} as const
